import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMessagesNavIconSecondary from './svgs/MessagesNavIconSecondary.js';
import SvgMessagesNavIcon from './svgs/MessagesNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var messagesNavIcon = (props => useIcon(SvgMessagesNavIcon, SvgMessagesNavIconSecondary, props));

export { messagesNavIcon as default };
